export const VALIDATION_STATUS = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    PARTIAL: 'PARTIAL',
    INFO: 'INFO',
};

export const isFieldValidated = (fieldName, validatedFields) => {
    if (!fieldName || !validatedFields || !Array.isArray(validatedFields)) {
        return false;
    }
    return validatedFields.includes(fieldName);
};

export const isFieldAutofilled = (fieldName, autofilledFields) => {
    if (!fieldName || !autofilledFields || !Array.isArray(autofilledFields)) {
        return false;
    }
    return autofilledFields.some((item) => item.field === fieldName);
};

export const getAutofilledValue = (fieldName, autofilledFields) => {
    if (!fieldName || !autofilledFields || !Array.isArray(autofilledFields)) {
        return null;
    }
    const field = autofilledFields.find((item) => item.field === fieldName);
    return field ? field.value : null;
};

export const shouldApplyAutofill = (fieldName, autofilledFields, currentValue) => {
    const autofilledValue = getAutofilledValue(fieldName, autofilledFields);

    if (autofilledValue === null) {
        return false;
    }

    return autofilledValue !== currentValue && autofilledValue !== '';
};

export const getAutofillUpdates = (autofilledFields, currentValues = {}) => {
    if (!autofilledFields || !Array.isArray(autofilledFields)) {
        return [];
    }

    return autofilledFields.filter((item) => shouldApplyAutofill(item.field, autofilledFields, currentValues[item.field]));
};

export const shouldSkipValidation = (fieldName, recentlyAutofilledFields) => {
    if (!recentlyAutofilledFields || !(recentlyAutofilledFields instanceof Set)) {
        return false;
    }
    return recentlyAutofilledFields.has(fieldName);
};

export default {
    VALIDATION_STATUS,
    isFieldValidated,
    isFieldAutofilled,
    getAutofilledValue,
    shouldApplyAutofill,
    getAutofillUpdates,
    shouldSkipValidation,
};
